
import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Fade from '@mui/material/Fade';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Notification = ({ open, onClose, message, severity }) => {

    useEffect(() => {
      if (open) {
        setTimeout(() => {
          onClose(); // Optionally call onClose here if needed
        }, 5000);
  
      }
    }, [open, onClose]);
    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
                open={open}
                autoHideDuration={null} // Set to null to manage the duration internally
                action={[]}
                TransitionComponent={Fade}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right', // Adjust the positioning here
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right', // Adjust the positioning here
                }}
                // onClose={onClose} 
            >
                <Alert severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}

export default Notification;
